import { CombineSplitOrdersShipments } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useCombineSplitOrdersShipmentsFeatureGate = () => usePlanFeatureGate(CombineSplitOrdersShipments);
